// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2WzpL","upload":"Small_upload__3zOAH","imageWrap":"Small_imageWrap__enJaa","removeBtn":"Small_removeBtn__19txY"};